module.exports = __webpack_public_path__ + "static/media/nu.aeed3c34.svg";